import { render } from "./bulkSupplierReportList.vue?vue&type=template&id=2a77a357&scoped=true"
import script from "./bulkSupplierReportList.vue?vue&type=script&lang=js"
export * from "./bulkSupplierReportList.vue?vue&type=script&lang=js"

import "./bulkSupplierReportList.vue?vue&type=style&index=0&id=2a77a357&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a77a357"]])

export default __exports__